export default{
  dev_mode: true,
  major_token_symbol: 'HIM',
  disabled_token_symbols: ['MAJOR', 'BCKG', "KRWH", "USDH", "HIC", "CNYH"], // disabled major tokens
  near_distance: 0.000235
}